import { Link } from "react-router-dom";
import { CircleAlert } from "lucide-react";

import { Card, CardContent, CardHeader } from "@/components/ui/card";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty";
import { Field, FieldContent, FieldLabel } from "@/components/ui/field";
import { Skeleton } from "@/components/ui/skeleton";
import { EM_DASH } from "routes/custom_tables/grid/cellHelpers";

export const RecordLink = ({ to, children }) => (
  <Link to={to} className="tw:text-primary! tw:hover:underline">
    {children}
  </Link>
);

export const RecordLoadError = ({ title }) => (
  <div className="tw:w-full">
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <CircleAlert />
        </EmptyMedia>
        <EmptyTitle>{title}</EmptyTitle>
        <EmptyDescription>Try again shortly.</EmptyDescription>
      </EmptyHeader>
    </Empty>
  </div>
);

export const DetailRow = ({ label, children }) => (
  <Field orientation="vertical">
    <FieldLabel className="tw:text-muted-foreground">{label}</FieldLabel>
    <FieldContent className="tw:min-w-0 tw:break-words tw:text-foreground">
      {children ?? EM_DASH}
    </FieldContent>
  </Field>
);

export const DetailGrid = ({ children }) => (
  <div className="tw:grid tw:grid-cols-1 tw:gap-5 tw:sm:grid-cols-2">
    {children}
  </div>
);

export const OverviewSkeleton = () => (
  <div className="tw:flex tw:w-full tw:max-w-7xl tw:flex-col tw:gap-4">
    {[0, 1, 2].map(key => (
      <Card key={key}>
        <CardHeader>
          <Skeleton className="tw:h-5 tw:w-40" />
        </CardHeader>
        <CardContent className="tw:flex tw:flex-col tw:gap-3">
          <Skeleton className="tw:h-4 tw:w-full" />
          <Skeleton className="tw:h-4 tw:w-2/3" />
        </CardContent>
      </Card>
    ))}
  </div>
);
